const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export default function generatePassword(length = 8) {
  return Array.from(
    { length },
    () => charset.charAt(Math.floor(Math.random() * charset.length))
  ).join('');
}